/**
 * Connect takes a callback that will be called after retrieving the users session
 * @example
 * connect((user, session) => {
 *   if (user) {
 *     console.log(`${user.name} is logged in`)
 *   } else {
 *     session.login({abortPath: '%2Fminside'})
 *   }
 * })
 */
export function connect(callback) {
  const key = 'onLoginReady';
  // Add callback queue placeholder if needed
  if (window[key] === undefined) {
    window[key] = function () {
      (window[key].q = window[key].q || []).push(arguments);
    };
  }

  // load script if needed
  loadOnce('/logginn.js');

  // add callback
  window[key](callback);
}

/**
 * loadOnce loads the given script IFF it is not already present in the DOM.
 * @param {string} src URL for script
 * @returns {undefined}
 */
function loadOnce(src) {
  const hasScript = document.querySelector(`script[src="${src}"]`);

  if (hasScript) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = src;

  document.head.appendChild(script);
}
